// i18n translations for D&D Campaign Tracker
// Default language: French

const translations = {
  fr: {
    // Common
    app_name: "WyrdMaker",
    app_subtitle: "Gestionnaire de campagne",
    loading: "Chargement...",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    create: "Créer",
    search: "Rechercher...",
    close: "Fermer",
    confirm: "Confirmer",
    back: "Retour",
    view_all: "Voir tout",
    no_results: "Aucun résultat",
    optional: "optionnel",
    
    // Auth
    login: "Connexion",
    register: "Inscription",
    logout: "Déconnexion",
    email: "Email",
    password: "Mot de passe",
    username: "Nom d'utilisateur",
    login_title: "Entrez dans l'aventure",
    register_title: "Rejoindre la guilde",
    no_account: "Pas encore de compte ?",
    has_account: "Déjà inscrit ?",
    login_error: "Email ou mot de passe incorrect",
    register_error: "Erreur lors de l'inscription",
    
    // Navigation
    nav_dashboard: "Tableau de bord",
    nav_campaigns: "Campagnes",
    nav_sessions: "Sessions",
    nav_quests: "Quêtes",
    nav_npcs: "PNJ",
    nav_locations: "Lieux",
    nav_maps: "Cartes",
    nav_travel: "Voyage",
    nav_treasure: "Trésors",
    nav_combat: "Combat",
    nav_messages: "Messages",
    nav_settings: "Paramètres",

    // Command Palette
    command_palette_placeholder: "Rechercher une quête, PNJ, lieu...",
    command_palette_no_results: "Aucun résultat trouvé",
    command_palette_quick_actions: "Actions rapides",
    command_palette_search_hint: "Recherche",

    // Notifications
    notif_title: "Notifications",
    notif_empty: "Aucune notification",
    notif_mark_all_read: "Tout marquer comme lu",
    notif_session_published: "Récap de session publiée",
    notif_session_created: "Nouvelle session planifiée",
    notif_quest_status_changed: "Statut de quête modifié",
    notif_npc_status_changed: "Statut de PNJ modifié",
    notif_lore_revealed: "Article d'encyclopédie révélé",
    notif_report_status_changed: "Statut du rapport modifié",
    notif_report_admin_response: "Réponse de l'administrateur",
    notif_just_now: "à l'instant",
    notif_minutes_ago: "il y a {n} min",
    notif_hours_ago: "il y a {n}h",
    notif_days_ago: "il y a {n}j",

    // Bug Reports
    report_button_title: "Signaler",
    report_dialog_title: "Signaler un bug ou une amélioration",
    report_type: "Type",
    report_type_bug: "Bug",
    report_type_feature: "Amélioration",
    report_title: "Titre",
    report_description: "Description",
    report_priority: "Priorité",
    report_priority_low: "Basse",
    report_priority_medium: "Moyenne",
    report_priority_high: "Haute",
    report_priority_critical: "Critique",
    report_submit: "Envoyer",
    report_submitting: "Envoi...",
    report_success: "Rapport envoyé avec succès",

    // Admin Email Templates
    admin_email_templates: "Templates Email",
    admin_email_templates_title: "Gestion des Templates Email",
    admin_email_templates_save: "Template sauvegardé",
    admin_email_templates_test_sent: "Email de test envoyé",
    admin_email_templates_seed: "Templates par défaut restaurés",

    // Admin Reports
    admin_reports: "Rapports",
    report_status_new: "Nouveau",
    report_status_acknowledged: "Acquitté",
    report_status_in_progress: "En cours",
    report_status_resolved: "Résolu",
    report_status_closed: "Fermé",
    report_admin_response: "Réponse admin",
    report_admin_respond: "Répondre",
    report_no_reports: "Aucun rapport",
    report_settings: "Paramètres",
    report_mode_disabled: "Désactivé",
    report_mode_all_users: "Tous les utilisateurs",
    report_mode_per_user: "Par utilisateur",
    report_mode_label: "Mode de rapport",
    report_mode_description_disabled: "Les rapports de bug sont désactivés pour tous les utilisateurs",
    report_mode_description_all_users: "Tous les utilisateurs peuvent soumettre des rapports",
    report_mode_description_per_user: "Seuls les utilisateurs autorisés peuvent soumettre des rapports",
    report_delete_confirm: "Êtes-vous sûr de vouloir supprimer ce rapport ?",
    report_detail: "Détail du rapport",
    report_by: "Par",
    report_created_at: "Créé le",

    // Landing
    landing_hero_title: "Maîtrisez Vos Campagnes",
    landing_hero_subtitle: "La plateforme tout-en-un pour les Maîtres du Jeu et leurs joueurs. Gérez vos campagnes, partagez vos cartes et vivez des aventures mémorables ensemble.",
    landing_cta: "Commencer l'aventure",
    landing_feature_1_title: "Sessions & Comptes-rendus",
    landing_feature_1_desc: "Planifiez vos sessions, suivez la présence et rédigez des comptes-rendus structurés.",
    landing_feature_2_title: "Quêtes & PNJ",
    landing_feature_2_desc: "Gérez vos intrigues, personnages et leurs relations complexes.",
    landing_feature_3_title: "Cartes Interactives",
    landing_feature_3_desc: "Créez des cartes avec des points d'intérêt liés à vos quêtes et lieux.",
    landing_feature_4_title: "Générateur de Trésors",
    landing_feature_4_desc: "Générez des trésors D&D 5e équilibrés en un clic.",
    landing_feature_5_title: "Tracker de Combat",
    landing_feature_5_desc: "Initiative, PV, conditions et partage en temps réel avec vos joueurs via SSE.",
    landing_feature_6_title: "Fiches de Personnage PDF",
    landing_feature_6_desc: "Importez vos PDF et superposez des champs interactifs. Compatible tout système.",
    landing_feature_7_title: "Brouillard de Guerre",
    landing_feature_7_desc: "Révélez progressivement vos cartes aux joueurs avec un pinceau de brouillard.",
    landing_feature_8_title: "Encyclopédie & Lore",
    landing_feature_8_desc: "Wiki intégré avec mentions @, liens bidirectionnels et niveaux de révélation.",
    landing_feature_9_title: "Lanceur de Dés 3D",
    landing_feature_9_desc: "Dés 3D animés, avantage/désavantage, dés explosifs et presets personnalisés.",
    landing_feature_10_title: "Musique & Soundboard",
    landing_feature_10_desc: "Bibliothèque audio avec playlists, crossfade et soundboard de 100+ effets sonores par catégorie.",
    landing_feature_11_title: "Graphe Relationnel",
    landing_feature_11_desc: "Visualisez les connexions entre PNJ, quêtes, lieux et articles de lore.",
    landing_feature_12_title: "Marketplace de Templates",
    landing_feature_12_desc: "Parcourez, importez et partagez des campagnes prêtes à jouer. Templates officiels, tri par difficulté et import en un clic.",
    landing_feature_13_title: "Créateur de Systèmes de Jeu",
    landing_feature_13_desc: "Créez vos propres systèmes de JDR : schéma JSON, 8 types de champs, éditeur PDF visuel et permissions par rôle.",
    landing_section_hero_features: "Gestion de campagne tout-en-un",
    landing_section_visual_title: "Conçu pour les MJ et les Joueurs",
    landing_section_visual_subtitle: "Des outils puissants pour le MJ, une expérience immersive pour les joueurs",
    landing_section_power_title: "Puissance Sous le Capot",
    landing_section_power_subtitle: "Des fonctionnalités avancées pour les tables exigeantes",
    landing_section_stats_campaigns: "Campagnes créées",
    landing_section_stats_sessions: "Sessions jouées",
    landing_section_stats_npcs: "PNJ gérés",
    landing_section_stats_maps: "Cartes explorées",

    // Landing v2
    landing_hero_title_v2: "Votre Campagne. Votre Légende.",
    landing_hero_subtitle_v2: "L'outil complet pour les Maîtres du Jeu et leurs joueurs. Gérez, partagez et vivez des aventures épiques.",
    landing_use_case_gm_title: "Maîtres du Jeu",
    landing_use_case_gm_desc: "Gérez combats, PNJ, cartes et quêtes depuis un seul tableau de bord. Gardez le contrôle de chaque session.",
    landing_use_case_player_title: "Joueurs",
    landing_use_case_player_desc: "Accédez à vos fiches de personnage, inventaire et notes de session en temps réel.",
    landing_use_case_worldbuilder_title: "Créateurs de Mondes",
    landing_use_case_worldbuilder_desc: "Encyclopédie, timeline, graphe relationnel : construisez un univers riche et cohérent.",
    landing_features_see_all: "Voir toutes les fonctionnalités",
    landing_trusted_by: "La confiance de centaines de tables",

    // Navigation public
    nav_features: "Fonctionnalités",
    nav_pricing: "Tarifs",
    nav_updates: "Nouveautés",
    nav_help: "Aide",
    nav_contact: "Contact",

    // Footer
    footer_product: "Produit",
    footer_support: "Support",
    footer_legal: "Légal",
    footer_tagline: "Forgez vos légendes autour de la table.",
    footer_copyright: "Tous droits réservés.",
    footer_terms: "Conditions d'utilisation",
    footer_privacy: "Politique de confidentialité",

    // Features Page
    features_page_title: "Fonctionnalités",
    features_page_subtitle: "Tout ce dont vous avez besoin pour gérer vos campagnes de JDR, du combat à la construction de monde.",
    features_category_campaign: "Gestion de Campagne",
    features_category_campaign_desc: "Planifiez, organisez et suivez chaque aspect de votre campagne.",
    features_category_combat: "Combat & Cartes",
    features_category_combat_desc: "Des outils en temps réel pour des combats épiques et l'exploration.",
    features_category_world: "Construction de Monde",
    features_category_world_desc: "Donnez vie à votre univers avec des outils narratifs puissants.",
    features_category_assets: "Ressources & Média",
    features_category_assets_desc: "Audio, équipement et trésors pour une immersion totale.",
    features_category_platform: "Plateforme",
    features_category_platform_desc: "Des outils avancés pour créer et partager vos systèmes de jeu.",
    features_cta: "Prêt à essayer ?",
    features_cta_desc: "Créez votre première campagne gratuitement.",

    // Pricing Page
    pricing_page_title: "Tarifs simples et transparents",
    pricing_page_subtitle: "Commencez gratuitement, évoluez quand vous êtes prêt.",
    pricing_free_name: "Aventurier",
    pricing_free_price: "0",
    pricing_free_desc: "Parfait pour découvrir la plateforme.",
    pricing_free_f1: "1 campagne active",
    pricing_free_f2: "5 PNJ par campagne",
    pricing_free_f3: "Tracker de combat basique",
    pricing_free_f4: "Lanceur de dés",
    pricing_free_f5: "Encyclopédie (10 articles)",
    pricing_pro_name: "Maître du Jeu",
    pricing_pro_price: "9",
    pricing_pro_desc: "Pour les MJ qui veulent tout débloquer.",
    pricing_pro_f1: "Campagnes illimitées",
    pricing_pro_f2: "PNJ et quêtes illimités",
    pricing_pro_f3: "Cartes avec brouillard de guerre",
    pricing_pro_f4: "Musique & Soundboard complet",
    pricing_pro_f5: "Fiches PDF personnalisées",
    pricing_pro_f6: "Graphe relationnel",
    pricing_pro_f7: "Support prioritaire",
    pricing_guild_name: "Guilde",
    pricing_guild_price: "25",
    pricing_guild_desc: "Pour les groupes et communautés.",
    pricing_guild_f1: "Tout le plan Pro",
    pricing_guild_f2: "Jusqu'à 10 MJ",
    pricing_guild_f3: "Marketplace privée",
    pricing_guild_f4: "Accès API",
    pricing_guild_f5: "Branding personnalisé",
    pricing_guild_f6: "Support dédié",
    pricing_popular: "Populaire",
    pricing_per_month: "/mois",
    pricing_start_free: "Commencer gratuitement",
    pricing_choose: "Choisir ce plan",
    pricing_contact_sales: "Contacter l'équipe",
    pricing_faq_title: "Questions fréquentes",
    pricing_faq_1_q: "Puis-je changer de plan à tout moment ?",
    pricing_faq_1_a: "Oui, vous pouvez upgrader ou downgrader votre plan à tout moment. Les changements prennent effet immédiatement.",
    pricing_faq_2_q: "Y a-t-il un engagement ?",
    pricing_faq_2_a: "Non, tous les plans sont sans engagement. Vous pouvez annuler à tout moment.",
    pricing_faq_3_q: "Mes données sont-elles sécurisées ?",
    pricing_faq_3_a: "Absolument. Vos données sont chiffrées et sauvegardées quotidiennement. Nous ne partageons jamais vos informations.",
    pricing_faq_4_q: "Le plan Guilde inclut-il un nombre illimité de joueurs ?",
    pricing_faq_4_a: "Oui, seul le nombre de MJ est limité. Chaque MJ peut inviter autant de joueurs que nécessaire.",

    // Updates Page
    updates_page_title: "Nouveautés",
    updates_page_subtitle: "Suivez les dernières améliorations et corrections de WyrdMaker.",
    updates_badge_new: "Nouveau",
    updates_badge_improved: "Amélioré",
    updates_badge_fixed: "Corrigé",

    // Help Page
    help_page_title: "Centre d'aide",
    help_page_subtitle: "Trouvez des réponses à vos questions les plus courantes.",
    help_search_placeholder: "Rechercher dans l'aide...",
    help_category_getting_started: "Premiers pas",
    help_category_campaigns: "Campagnes",
    help_category_technical: "Technique",
    help_quick_links_title: "Liens rapides",
    help_faq_1_q: "Comment créer ma première campagne ?",
    help_faq_1_a: "Après votre inscription, cliquez sur 'Nouvelle campagne' depuis le tableau de bord. Donnez un nom, choisissez un système de jeu et invitez vos joueurs.",
    help_faq_2_q: "Comment inviter des joueurs à ma campagne ?",
    help_faq_2_a: "Dans les paramètres de la campagne, utilisez la section 'Membres' pour envoyer des invitations par email ou partager un lien d'invitation.",
    help_faq_3_q: "Comment fonctionne le tracker de combat ?",
    help_faq_3_a: "Le tracker gère l'initiative, les PV et les conditions. Les joueurs voient les informations en temps réel via un lien de partage.",
    help_faq_4_q: "Puis-je importer mes propres fiches PDF ?",
    help_faq_4_a: "Oui ! Uploadez un PDF de fiche de personnage, puis utilisez l'éditeur visuel pour positionner des champs interactifs dessus.",
    help_faq_5_q: "Comment utiliser le brouillard de guerre ?",
    help_faq_5_a: "Uploadez une carte, activez le brouillard de guerre, puis utilisez le pinceau pour révéler progressivement les zones aux joueurs.",
    help_faq_6_q: "Les données sont-elles synchronisées en temps réel ?",
    help_faq_6_a: "Oui, le combat et les cartes utilisent SSE (Server-Sent Events) pour une synchronisation en temps réel entre le MJ et les joueurs.",
    help_faq_7_q: "Quels systèmes de jeu sont supportés ?",
    help_faq_7_a: "WyrdMaker supporte D&D 5e et Wrath & Glory nativement, et vous pouvez créer vos propres systèmes avec le Game System Builder.",
    help_faq_8_q: "Comment contacter le support ?",
    help_faq_8_a: "Utilisez la page Contact ou le bouton de signalement de bug intégré à l'application.",

    // Contact Page
    contact_page_title: "Nous contacter",
    contact_page_subtitle: "Une question, un bug ou une suggestion ? Nous sommes à votre écoute.",
    contact_name_label: "Nom",
    contact_email_label: "Email",
    contact_subject_label: "Sujet",
    contact_message_label: "Message",
    contact_subject_general: "Question générale",
    contact_subject_bug: "Signaler un bug",
    contact_subject_feature: "Suggestion de fonctionnalité",
    contact_subject_other: "Autre",
    contact_submit: "Envoyer le message",
    contact_success: "Message envoyé ! Nous vous répondrons sous 48h.",
    contact_info_title: "Autres moyens de nous joindre",
    contact_response_time: "Réponse sous 48h",
    contact_email_info: "support@wyrdmaker.com",
    contact_discord_info: "Rejoignez notre Discord",

    // Dashboard
    dashboard_welcome: "Bienvenue",
    dashboard_recent_sessions: "Sessions récentes",
    dashboard_active_quests: "Quêtes actives",
    dashboard_npcs: "PNJ rencontrés",
    dashboard_no_campaigns: "Aucune campagne",
    dashboard_create_first: "Créez votre première campagne pour commencer l'aventure !",
    
    // Campaigns
    campaign: "Campagne",
    campaigns: "Campagnes",
    campaign_create: "Nouvelle campagne",
    campaign_name: "Nom de la campagne",
    campaign_description: "Description",
    campaign_universe: "Univers",
    campaign_style: "Style de jeu",
    campaign_house_rules: "Règles maison",
    campaign_banner: "Image de bannière",
    campaign_members: "Membres",
    campaign_invite: "Inviter des joueurs",
    campaign_invite_code: "Code d'invitation",
    campaign_join: "Rejoindre une campagne",
    campaign_role_owner: "Maître du Jeu",
    campaign_role_editor: "Co-MJ",
    campaign_role_member: "Joueur",
    campaign_role_readonly: "Spectateur",
    
    // Sessions
    session: "Session",
    sessions: "Sessions",
    session_create: "Nouvelle session",
    session_title: "Titre",
    session_date: "Date et heure",
    session_location: "Lieu (IRL/online)",
    session_duration: "Durée estimée (min)",
    session_agenda: "Ordre du jour",
    session_prep: "Notes de préparation MJ",
    session_summary: "Résumé narratif",
    session_key_events: "Événements clés",
    session_decisions: "Décisions des joueurs",
    session_publish: "Publier aux joueurs",
    session_published: "Publié",
    session_draft: "Brouillon",
    session_attendance: "Présence",
    session_confirmed: "Confirmé",
    session_absent: "Absent",
    session_invited: "Invité",
    
    // Quests
    quest: "Quête",
    quests: "Quêtes",
    quest_create: "Nouvelle quête",
    quest_title: "Titre",
    quest_summary: "Résumé",
    quest_type: "Type",
    quest_type_main: "Principale",
    quest_type_side: "Secondaire",
    quest_type_personal: "Personnelle",
    quest_status: "Statut",
    quest_status_unknown: "Inconnue",
    quest_status_known: "Connue",
    quest_status_in_progress: "En cours",
    quest_status_completed: "Terminée",
    quest_status_failed: "Échouée",
    quest_status_abandoned: "Abandonnée",
    quest_objectives: "Objectifs",
    quest_rewards: "Récompenses",
    quest_giver: "Donneur de quête",
    quest_consequences: "Conséquences (MJ)",
    quest_hints: "Indices possibles",
    quest_acts_title: "Actes (MJ)",
    quest_acts_gm_only: "Visible uniquement par le MJ",
    quest_acts_empty: "Aucun acte défini. Découpez votre scénarisation ici.",
    quest_acts_add: "Ajouter un acte",
    quest_acts_move_up: "Monter",
    quest_acts_move_down: "Descendre",
    quest_acts_added: "Acte ajouté",
    quest_acts_title_required: "Le titre est requis",

    // NPCs
    npc: "PNJ",
    npcs: "PNJ",
    npc_create: "Nouveau PNJ",
    npc_name: "Nom",
    npc_alias: "Alias",
    npc_race: "Race",
    npc_faction: "Faction",
    npc_role: "Rôle",
    npc_appearance: "Apparence",
    npc_voice: "Voix et manies",
    npc_public_info: "Informations publiques",
    npc_secrets: "Secrets (MJ)",
    npc_what_they_know: "Ce qu'ils savent",
    npc_what_they_want: "Ce qu'ils veulent",
    npc_what_they_hide: "Ce qu'ils cachent",
    npc_status: "Statut",
    npc_status_alive: "Vivant",
    npc_status_dead: "Mort",
    npc_status_missing: "Disparu",
    npc_status_hostile: "Hostile",
    npc_status_ally: "Allié",
    npc_relations: "Relations",
    
    // Locations
    location: "Lieu",
    locations: "Lieux",
    location_create: "Nouveau lieu",
    location_name: "Nom",
    location_type: "Type",
    location_parent: "Lieu parent",
    location_description: "Description publique",
    location_mj_notes: "Notes MJ",
    location_events: "Événements possibles",
    location_types: {
      world: "Monde",
      continent: "Continent",
      kingdom: "Royaume",
      region: "Région",
      city: "Ville",
      district: "Quartier",
      dungeon: "Donjon",
      room: "Salle"
    },
    
    // Visibility
    visibility: "Visibilité",
    visibility_mj_only: "MJ uniquement",
    visibility_players: "Joueurs",
    visibility_custom: "Personnalisée",
    
    // Messages
    success_saved: "Enregistré avec succès",
    success_deleted: "Supprimé avec succès",
    success_published: "Publié avec succès",
    error_generic: "Une erreur est survenue",
    error_required: "Ce champ est requis",
    
    // Theme
    theme_light: "Clair",
    theme_dark: "Sombre",
    theme_toggle: "Changer de thème",
    
    // Language
    language: "Langue",
    language_fr: "Français",
    language_en: "English",

    // Admin
    nav_admin: "Administration",
    admin_dashboard: "Tableau de bord admin",
    admin_users: "Utilisateurs",
    admin_campaigns: "Campagnes",
    admin_settings: "Paramètres du site",
    admin_audit_logs: "Logs d'audit",
    admin_system: "Système",
    admin_maintenance: "Maintenance",

    admin_total_users: "Utilisateurs totaux",
    admin_active_users: "Utilisateurs actifs",
    admin_total_campaigns: "Campagnes totales",
    admin_active_campaigns: "Campagnes actives",
    admin_archived_campaigns: "Campagnes archivées",
    admin_total_sessions: "Sessions jouées",
    admin_total_npcs: "PNJ créés",
    admin_total_quests: "Quêtes créées",
    admin_total_locations: "Lieux créés",
    admin_total_maps: "Cartes créées",
    admin_total_encounters: "Rencontres créées",

    admin_user_create: "Ajouter un utilisateur",
    admin_user_create_desc: "Créer un nouveau compte utilisateur",
    admin_user_list: "Liste des utilisateurs",
    admin_user_detail: "Détail utilisateur",
    admin_user_activate: "Activer",
    admin_user_deactivate: "Désactiver",
    admin_user_promote: "Promouvoir admin",
    admin_user_demote: "Rétrograder",
    admin_user_reset_password: "Réinitialiser le mot de passe",
    admin_user_delete: "Supprimer l'utilisateur",
    admin_user_last_login: "Dernière connexion",
    admin_user_status_active: "Actif",
    admin_user_status_disabled: "Désactivé",
    admin_user_campaigns_count: "Campagnes",
    admin_user_confirm_delete: "Êtes-vous sûr de vouloir supprimer cet utilisateur ? Cette action est irréversible.",
    admin_user_confirm_deactivate: "Êtes-vous sûr de vouloir désactiver ce compte ?",
    admin_new_password: "Nouveau mot de passe",

    admin_settings_general: "Général",
    admin_settings_smtp: "Email (SMTP)",
    admin_settings_security: "Sécurité",
    admin_settings_announcements: "Annonces",

    admin_site_name: "Nom du site",
    admin_site_description: "Description du site",
    admin_site_url: "URL publique",
    admin_registration_enabled: "Inscriptions ouvertes",
    admin_max_users: "Nombre max d'utilisateurs (0 = illimité)",
    admin_max_campaigns: "Max campagnes par utilisateur (0 = illimité)",
    admin_default_language: "Langue par défaut",
    admin_logo_url: "URL du logo",
    admin_favicon_url: "URL du favicon",

    admin_smtp_host: "Hôte SMTP",
    admin_smtp_port: "Port SMTP",
    admin_smtp_user: "Utilisateur SMTP",
    admin_smtp_password: "Mot de passe SMTP",
    admin_smtp_tls: "Utiliser TLS",
    admin_smtp_from_email: "Email expéditeur",
    admin_smtp_from_name: "Nom expéditeur",
    admin_email_enabled: "Emails activés",
    admin_smtp_test: "Envoyer un email de test",
    admin_smtp_test_success: "Email de test envoyé avec succès",
    admin_smtp_test_error: "Erreur lors de l'envoi de l'email de test",

    admin_jwt_expiration: "Expiration JWT (heures)",
    admin_password_min_length: "Longueur min. mot de passe",
    admin_cors_origins: "Origines CORS (séparées par des virgules)",

    admin_announcement: "Message d'annonce global",
    admin_announcement_help: "Ce message sera affiché à tous les utilisateurs connectés.",

    admin_campaign_owner: "Propriétaire",
    admin_campaign_members_count: "Membres",
    admin_campaign_archive: "Archiver",
    admin_campaign_unarchive: "Désarchiver",
    admin_campaign_delete: "Supprimer",
    admin_campaign_confirm_delete: "Êtes-vous sûr de vouloir supprimer cette campagne ? Toutes les données associées seront perdues.",

    admin_audit_action: "Action",
    admin_audit_admin: "Administrateur",
    admin_audit_target: "Cible",
    admin_audit_date: "Date",
    admin_audit_details: "Détails",

    admin_health_check: "État des services",
    admin_db_status: "Base de données",
    admin_db_size: "Taille de la BDD",
    admin_media_status: "Serveur média",
    admin_cleanup_invites: "Nettoyer les invitations expirées",
    admin_cleanup_tokens: "Nettoyer les tokens expirés",
    admin_cleanup_success: "Nettoyage effectué",
    admin_service_online: "En ligne",
    admin_service_offline: "Hors ligne",
    admin_songs_count: "Musiques disponibles",
    admin_back_to_site: "Retour au site",

    // Game Systems (admin)
    admin_game_systems: "Systèmes de jeu",
    admin_game_system_create: "Nouveau système",
    admin_game_system_slug: "Identifiant (slug)",
    admin_game_system_name: "Nom",
    admin_game_system_publisher: "Éditeur",
    admin_game_system_version: "Version",
    admin_game_system_description: "Description",
    admin_game_system_builtin: "Intégré",
    admin_game_system_active: "Actif",
    admin_game_system_archive: "Désactiver",
    admin_game_system_delete: "Supprimer",
    admin_game_system_confirm_delete: "Supprimer ce système ? Les templates associés seront aussi supprimés.",
    admin_game_system_no_delete_builtin: "Les systèmes intégrés ne peuvent pas être supprimés.",
    admin_game_system_no_delete_campaigns: "Ce système est utilisé par des campagnes actives.",
    admin_system_templates: "Templates de fiche",
    admin_template_create: "Nouveau template",
    admin_template_name: "Nom du template",
    admin_template_version: "Version",
    admin_template_description: "Description",
    admin_template_fields_schema: "Schéma JSON (fields_schema)",
    admin_template_layout: "Mise en page (layout)",
    admin_template_default: "Template par défaut",
    admin_template_confirm_delete: "Supprimer ce template ? Les fiches existantes ne seront pas affectées.",
    admin_template_no_delete: "Ce template est utilisé par des fiches de personnage.",
    admin_json_invalid: "JSON invalide",

    // Admin — Common terms
    admin_status: "Statut",
    admin_name: "Nom",
    admin_universe: "Univers",
    admin_created_at: "Créé le",
    admin_archived: "Archivée",
    admin_yes: "Oui",
    admin_no: "Non",
    admin_details: "Détails",
    admin_statistics: "Statistiques",
    admin_platform_content: "Contenu de la plateforme",
    admin_total_lore: "Articles de lore",
    admin_count_users: "utilisateurs",
    admin_count_campaigns: "campagnes",
    admin_count_entries: "entrées",
    admin_filter_action: "Filtrer par action...",
    admin_test_btn: "Tester",
    admin_db_name: "Base",
    admin_data_size: "Données",
    admin_storage_size: "Stockage",
    admin_collections_label: "Collections",
    admin_media_label: "Médias",
    admin_total_size: "Taille totale",
    admin_user_edit: "Modifier l'utilisateur",
    admin_user_language: "Langue",
    admin_export_csv: "Exporter CSV",
    admin_maintenance_confirm_title: "Confirmer le nettoyage",
    admin_maintenance_confirm_desc: "Cette action va supprimer les données expirées. Continuer ?",
    admin_published_at: "Publié le",
    admin_language_fr: "Français",
    admin_language_en: "Anglais",
    marketplace_language: "Langue du contenu",

    // Admin — Game systems / Templates extras
    admin_game_system_none: "Aucun système de jeu configuré",
    admin_game_system_disabled: "Désactivé",
    admin_game_system_reenable: "Réactiver",
    admin_game_system_slug_help: "Identifiant unique, non modifiable après création.",
    admin_placeholder_short_desc: "Description courte...",
    admin_template_none: "Aucun template configuré",
    admin_template_default_badge: "Par défaut",
    admin_template_sections_count: "section(s)",
    admin_template_fields_count: "champ(s)",
    admin_template_pdf_builder: "Ouvrir le PDF Builder",
    admin_template_preview: "Aperçu",
    admin_template_set_default: "Définir par défaut",
    admin_template_tab_general: "Général",
    admin_template_example: "Exemple de section",

    // Admin — Audio
    admin_audio_title: "Musiques",
    admin_audio_subtitle: "Gestion de la bibliothèque audio, des tags et des collections",
    admin_audio_library: "Bibliothèque",
    admin_audio_tags: "Tags",
    admin_audio_collections: "Collections",
    admin_audio_total_tracks: "tracks au total",
    admin_audio_upload_hint: "Glissez des fichiers audio ici ou",
    admin_audio_browse: "parcourir",
    admin_audio_upload_formats: "MP3, WAV, OGG, FLAC — max 150 Mo / fichier",
    admin_audio_edit_track: "Modifier le track",
    admin_audio_title_label: "Titre (épisodes)",
    admin_audio_tags_label: "Tags (séparés par virgule)",
    admin_audio_collections_label: "Collections (IDs séparés par virgule)",
    admin_audio_active: "Actif (visible pour les MJ)",
    admin_audio_change_cover: "Changer la cover",
    admin_audio_choose_image: "Choisir une image",
    admin_audio_save_error: "Erreur lors de la sauvegarde",
    admin_audio_import_title: "Importer des fichiers",
    admin_audio_pending: "En attente",
    admin_audio_uploading: "Upload...",
    admin_audio_done: "OK",
    admin_audio_filter_tag: "Filtrer par tag",
    admin_audio_all_tags: "Tous les tags",
    admin_audio_all_statuses: "Tous statuts",
    admin_audio_active_only: "Actifs",
    admin_audio_disabled_only: "Désactivés",
    admin_audio_inactive: "Inactif",
    admin_audio_no_tracks: "Aucun track trouvé.",
    admin_audio_delete_track: "Supprimer ce track ?",
    admin_audio_permanent_delete: "Suppression définitive (efface le fichier + métadonnées)",
    admin_audio_soft_delete_hint: "Sans cocher : désactivation uniquement (fichier conservé).",
    admin_audio_delete_permanent: "Supprimer définitivement",
    admin_audio_deactivate: "Désactiver",
    admin_audio_tags_title: "Tags Audio",
    admin_audio_tags_count: "tag(s) dans la bibliothèque",
    admin_audio_add_tag: "Ajouter un tag",
    admin_audio_tag_placeholder: "nom du tag (ex: boss)",
    admin_audio_rename: "Renommer",
    admin_audio_delete_tag_title: "Supprimer le tag",
    admin_audio_delete_tag_desc: "Ce tag sera retiré de tous les tracks. Cette action est irréversible.",
    admin_audio_collections_title: "Collections Audio",
    admin_audio_new_collection: "Nouvelle collection",
    admin_audio_edit_collection: "Modifier la collection",
    admin_audio_name_required: "Le nom est requis",
    admin_audio_description: "Description",
    admin_audio_description_placeholder: "Description optionnelle",
    admin_audio_cover_image: "Image de couverture",
    admin_audio_collection_empty: "Collection vide",
    admin_audio_no_collections: "Aucune collection.",
    admin_audio_add_tracks: "Ajouter des tracks",
    admin_audio_add_tracks_to: "Ajouter des tracks à",
    admin_audio_search_tracks: "Rechercher un track...",
    admin_audio_in_list: "Dans la liste",
    admin_audio_not_found: "Introuvable",
    admin_audio_delete_collection_title: "Supprimer la collection",
    admin_audio_delete_collection_desc: "Les tracks ne seront pas effacés, seulement retirés de cette collection.",
    admin_audio_series: "Série",
    admin_audio_series_placeholder: "ex: Ambiance de combat",

    // Player Inventory
    nav_inventory: "Inventaire",
    inventory_title: "Mon Inventaire",
    inventory_empty: "Votre inventaire est vide",
    inventory_empty_desc: "Le MJ n'a pas encore attribu\u00e9 d'\u00e9quipement \u00e0 votre personnage.",
    inventory_item_count: "objets dans l'inventaire",
    equipment_assign_to: "Attribuer aux joueurs",
    equipment_assigned_to: "Attribu\u00e9 \u00e0",
    equipment_no_assignment: "Non attribu\u00e9",
    equipment_holographic: "Carte holographique",

    // Character Sheets
    nav_character_sheet: "Ma fiche",
    nav_gm_characters: "Fiches joueurs",
    gm_characters_title: "Fiches des joueurs",
    gm_characters_player: "Joueur",
    gm_characters_character: "Personnage",
    gm_characters_status: "Statut",
    gm_characters_completion: "Complétude",
    gm_characters_last_modified: "Dernière modif.",
    gm_characters_actions: "Actions",
    gm_characters_sheet_present: "Créée",
    gm_characters_sheet_missing: "Manquante",
    gm_characters_open: "Ouvrir",
    gm_characters_create: "Créer",
    gm_characters_view_as_player: "Vue joueur",
    gm_characters_view_as_gm: "Vue MJ",
    character_sheet: "Fiche de personnage",
    character_sheets: "Fiches de personnage",
    character_sheet_create: "Créer ma fiche",
    character_sheet_edit: "Modifier la fiche",
    character_sheet_save: "Enregistrer la fiche",
    character_sheet_no_system: "Aucun système de jeu configuré pour cette campagne.",
    character_sheet_no_system_hint: "Demandez au MJ d'associer un système de jeu dans les paramètres de la campagne.",
    character_sheet_no_sheet: "Vous n'avez pas encore de fiche de personnage.",
    character_sheet_no_template: "Aucun template de fiche disponible pour ce système.",
    character_sheet_select_template: "Choisir un template",
    character_sheet_viewing: "Fiche de",
    character_sheet_gm_view: "Vue MJ — toutes les sections visibles",
    character_sheet_other_player: "Vue joueur — sections restreintes",
    character_sheet_readonly: "En lecture seule",
    character_sheet_public: "Visible aux autres joueurs",
    character_sheet_private: "Privée",

    // Campaign system
    campaign_system: "Système de jeu",
    campaign_system_none: "Aucun système",
    campaign_system_change: "Changer de système",
    campaign_system_select: "Sélectionner un système",
    campaign_system_optional: "Système de jeu (optionnel)",

    // Historique des modifications de fiche
    history_tab: "Historique",
    history_loading: "Chargement de l'historique...",
    history_no_entries: "Aucune modification enregistrée.",
    history_filter_from: "Depuis",
    history_filter_to: "Jusqu'au",
    history_filter_path: "Champ (filtre)",
    history_filter_apply: "Filtrer",
    history_filter_reset: "Réinitialiser",
    history_load_more: "Charger plus",
    history_role_player: "Joueur",
    history_role_gm: "MJ",
    history_role_admin: "Admin",
    history_action_create: "Création de la fiche",
    history_action_update: "Modification",
    history_gm_only_hidden: "(champs MJ masqués)",
    history_changed_fields: "champ modifié",
    history_changed_fields_plural: "champs modifiés",
    history_empty: "vide",

    // PDF Builder
    pdf_builder_title: "PDF Builder",
    pdf_builder_subtitle: "Construisez votre fiche en annotant un PDF existant",
    pdf_builder_load_pdf: "Charger un PDF",
    pdf_builder_uploading: "Téléversement...",
    pdf_builder_loaded: "PDF chargé",
    pdf_builder_page_of: "Page {0} sur {1}",
    pdf_builder_draw_hint: "Cliquez-glissez sur le PDF pour créer un champ",
    pdf_builder_annotations: "Champs annotés",
    pdf_builder_no_annotations: "Aucun champ annoté pour l'instant",
    pdf_builder_field_key: "Clé du champ",
    pdf_builder_field_label: "Libellé",
    pdf_builder_field_type: "Type de champ",
    pdf_builder_section_title: "Titre de section",
    pdf_builder_font_size: "Taille de police",
    pdf_builder_visibility: "Visibilité",
    pdf_builder_editable_by: "Modifiable par",
    pdf_builder_required: "Requis",
    pdf_builder_min: "Min",
    pdf_builder_max: "Max",
    pdf_builder_resource_max_key: "Clé du maximum",
    pdf_builder_save: "Générer & Sauvegarder",
    pdf_builder_saving: "Sauvegarde...",
    pdf_builder_saved: "Template mis à jour avec succès",
    pdf_builder_new_field: "Nouveau champ",
    pdf_builder_edit_field: "Modifier le champ",
    pdf_builder_upload_prompt: "Téléversez un PDF de fiche de personnage pour commencer",
    pdf_builder_choose: "Choisir un PDF",

    // PDF Mode (Character Sheet)
    pdf_mode_tab: "Vue PDF",
    pdf_mode_saving: "Sauvegarde...",
    pdf_mode_version_conflict: "Conflit de version — rechargez la page et réessayez",
    pdf_mode_no_overlay: "Aucun PDF configuré pour ce template",
    pdf_mode_export: "Exporter PDF",
    pdf_mode_export_error: "Erreur lors de l'export PDF",
    pdf_mode_engine_error: "Impossible de charger le moteur PDF",
    pdf_mode_load_error: "Impossible de charger le PDF",
    pdf_mode_retry: "Réessayer",
    pdf_mode_loading: "Chargement du PDF...",

    // Marketplace
    marketplace: "Marketplace",
    marketplace_browse: "Parcourir le Marketplace",
    marketplace_hero_title: "Bibliothèque de Templates",
    marketplace_hero_subtitle: "Découvrez et importez des campagnes prêtes à jouer créées par la communauté",
    marketplace_search_placeholder: "Rechercher un template...",
    marketplace_featured: "Mis en avant",
    marketplace_new: "Nouveautés",
    marketplace_popular: "Populaires",
    marketplace_all_templates: "Tous les templates",
    marketplace_no_results: "Aucun template trouvé",
    marketplace_no_results_desc: "Essayez d'ajuster vos filtres ou votre recherche",
    marketplace_import: "Importer cette campagne",
    marketplace_importing: "Import en cours...",
    marketplace_imported: "Campagne importée avec succès !",
    marketplace_publish: "Publier au Marketplace",
    marketplace_publish_title: "Publier un template",
    marketplace_publish_desc: "Partagez votre campagne avec la communauté en la transformant en template",
    marketplace_name: "Nom du template",
    marketplace_short_desc: "Description courte",
    marketplace_long_desc: "Description détaillée",
    marketplace_category: "Catégorie",
    marketplace_difficulty: "Difficulté",
    marketplace_universe: "Univers",
    marketplace_game_system: "Système de jeu",
    marketplace_tags: "Tags (séparés par des virgules)",
    marketplace_cover_url: "URL de l'image de couverture",
    marketplace_category_oneshot: "One-shot",
    marketplace_category_campaign: "Campagne",
    marketplace_category_module: "Module",
    marketplace_category_adventure: "Aventure",
    marketplace_difficulty_beginner: "Débutant",
    marketplace_difficulty_intermediate: "Intermédiaire",
    marketplace_difficulty_advanced: "Avancé",
    marketplace_difficulty_expert: "Expert",
    marketplace_status_draft: "Brouillon",
    marketplace_status_pending: "En attente",
    marketplace_status_published: "Publié",
    marketplace_status_hidden: "Masqué",
    marketplace_included_content: "Contenu inclus",
    marketplace_by: "par",
    marketplace_imports_count: "imports",
    marketplace_import_success: "Campagne importée avec succès !",
    marketplace_publish_success: "Template soumis avec succès !",
    marketplace_official: "Officiel",
    marketplace_community: "Communautaire",
    marketplace_detail: "Voir le détail",
    marketplace_back: "Retour au Marketplace",
    marketplace_all_categories: "Toutes les catégories",
    marketplace_all_difficulties: "Toutes les difficultés",
    marketplace_sort_recent: "Plus récents",
    marketplace_sort_popular: "Plus populaires",
    marketplace_sort_name: "Alphabétique",
    admin_marketplace: "Marketplace",
    admin_marketplace_templates: "Templates",
    admin_marketplace_settings: "Paramètres",
    admin_marketplace_publish_mode: "Mode de publication",
    admin_marketplace_mode_admin_only: "Administrateurs uniquement",
    admin_marketplace_mode_global: "Tous les utilisateurs",
    admin_marketplace_mode_per_user: "Par utilisateur",
    admin_marketplace_mode_admin_only_desc: "Seuls les administrateurs peuvent publier des templates",
    admin_marketplace_mode_global_desc: "Tous les utilisateurs peuvent proposer des templates",
    admin_marketplace_mode_per_user_desc: "Activez la publication utilisateur par utilisateur",
    admin_marketplace_featured: "Mis en avant",
    admin_marketplace_official: "Officiel",
    admin_marketplace_confirm_delete: "Supprimer ce template du marketplace ?",
    admin_marketplace_publish_template: "Publier",
    admin_marketplace_hide_template: "Masquer",
    admin_marketplace_all_statuses: "Tous les statuts",
    admin_marketplace_user_permissions: "Permissions utilisateurs",
    admin_marketplace_can_publish: "Peut publier",
    admin_marketplace_save_settings: "Sauvegarder les paramètres",
    admin_marketplace_settings_saved: "Paramètres sauvegardés",
    admin_marketplace_no_templates: "Aucun template dans le marketplace",
    admin_marketplace_pending_count: "En attente de validation",
    admin_marketplace_open_campaign: "Ouvrir la campagne",
    admin_marketplace_open_campaign_desc: "Importer le contenu du template comme campagne éditable",
    admin_marketplace_opening: "Ouverture...",
    admin_marketplace_save_to_template: "Sauvegarder vers le template",
    admin_marketplace_save_to_template_desc: "Resynchroniser les modifications de la campagne vers le template marketplace",
    admin_marketplace_saving: "Sauvegarde...",
    admin_marketplace_save_success: "Données de la campagne sauvegardées dans le template",
    admin_marketplace_open_success: "Campagne ouverte avec succès",
    admin_marketplace_campaign_exists: "Campagne d'édition déjà existante — ouverture",
    admin_marketplace_linked_campaign: "Campagne liée",
    admin_marketplace_unlink_campaign: "Délier la campagne",
    admin_marketplace_unlink_confirm: "Délier cette campagne du template ? La campagne restera accessible mais ne sera plus synchronisée avec le template.",
    marketplace_linked_template: "Template marketplace lié",
    marketplace_save_back: "Sauvegarder vers le template",
    marketplace_save_back_desc: "Mettre à jour le template marketplace avec les données actuelles de cette campagne",
    marketplace_save_back_success: "Template marketplace mis à jour avec succès",
    marketplace_save_back_confirm: "Sauvegarder les modifications de cette campagne vers le template marketplace ?",
    campaign_delete: "Supprimer la campagne",
    campaign_delete_confirm_title: "Supprimer cette campagne ?",
    campaign_delete_confirm_warning: "Cette action est irréversible. Toutes les données de cette campagne seront définitivement supprimées :",
    campaign_delete_confirm_list: "Sessions, quêtes, PNJ, lieux, cartes, rencontres, trésors, fiches de personnage, articles de lore, événements de timeline",
    campaign_delete_confirm_marketplace: "Le template marketplace associé ne sera pas affecté.",
    campaign_delete_confirm_input: "Tapez le nom de la campagne pour confirmer :",
    campaign_delete_success: "Campagne supprimée avec succès",
    campaign_deleting: "Suppression...",
    campaign_leave: "Quitter la campagne",
    campaign_leave_confirm: "Voulez-vous vraiment quitter cette campagne ? Vous ne pourrez la rejoindre qu'avec un nouveau code d'invitation.",
    campaign_leave_success: "Vous avez quitté la campagne",

    // Treasure module — tabs
    treasure_tab_generator: "Générateur",
    treasure_tab_library: "Bibliothèque",
    treasure_tab_vault: "Coffre",
    treasure_stats_total: "Total GP",
    treasure_stats_items: "Objets",
    treasure_stats_favorites: "Favoris",

    // Generator
    treasure_generate: "Générer un trésor",
    treasure_method: "Méthode de génération",
    treasure_method_level: "Par niveau",
    treasure_method_cr: "Par difficulté (CR)",
    treasure_method_budget: "Par budget (GP)",
    treasure_method_location: "Par type de lieu",
    treasure_method_rarity: "Par rareté",
    treasure_party_level: "Niveau du groupe",
    treasure_challenge_rating: "Facteur de puissance",
    treasure_budget_gp: "Budget en PO",
    treasure_location_type: "Type de lieu",
    treasure_target_rarity: "Rareté cible",
    treasure_estimate: "Budget estimé",
    treasure_generate_btn: "Lancer la génération",
    treasure_reroll: "Relancer",
    treasure_save_to_vault: "Sauvegarder dans le Coffre",
    treasure_section_coins: "Monnaie",
    treasure_section_gems: "Gemmes",
    treasure_section_art: "Objets d'art",
    treasure_section_magic: "Objets magiques",
    treasure_section_story: "Éléments narratifs",
    treasure_convert_to_card: "Convertir en carte",
    treasure_converted: "Objet converti en carte d'équipement",

    // Equipment / Library
    equipment_create: "Créer un équipement",
    equipment_edit: "Modifier l'équipement",
    equipment_delete: "Supprimer l'équipement",
    equipment_delete_confirm: "Voulez-vous vraiment supprimer cet équipement ?",
    equipment_duplicate: "Dupliquer",
    equipment_duplicated: "Équipement dupliqué",
    equipment_toggle_favorite: "Favori",
    equipment_name: "Nom",
    equipment_description: "Description",
    equipment_effect: "Effet",
    equipment_stats: "Statistiques",
    equipment_weight: "Poids (lb)",
    equipment_value: "Valeur (PO)",
    equipment_slot: "Emplacement",
    equipment_charges: "Charges",
    equipment_max_charges: "Charges max",
    equipment_bonus: "Bonus",
    equipment_requirements: "Prérequis",
    equipment_tags: "Tags (séparés par des virgules)",
    equipment_image_url: "URL de l'image",
    equipment_saved: "Équipement sauvegardé",
    equipment_deleted: "Équipement supprimé",
    equipment_collection_count: "équipements",
    equipment_no_items: "Aucun équipement trouvé",
    equipment_no_items_desc: "Créez votre premier équipement ou convertissez un objet magique depuis le Coffre.",

    // Types
    equipment_type_weapon: "Arme",
    equipment_type_armor: "Armure",
    equipment_type_potion: "Potion",
    equipment_type_scroll: "Parchemin",
    equipment_type_wondrous: "Objet merveilleux",
    equipment_type_ring: "Anneau",
    equipment_type_wand: "Baguette",
    equipment_type_staff: "Bâton",
    equipment_type_ammunition: "Munition",
    equipment_type_tool: "Outil",
    equipment_type_material: "Matériau",
    equipment_type_quest_item: "Objet de quête",

    // Categories
    equipment_category_equipment: "Équipement",
    equipment_category_consumable: "Consommable",
    equipment_category_material: "Matériau",
    equipment_category_quest_item: "Objet de quête",
    equipment_category_artifact: "Artefact",

    // Rarities
    rarity_common: "Commun",
    rarity_uncommon: "Peu commun",
    rarity_rare: "Rare",
    rarity_very_rare: "Très rare",
    rarity_legendary: "Légendaire",
    rarity_artifact: "Artefact",

    // Slots
    slot_head: "Tête",
    slot_chest: "Torse",
    slot_hands: "Mains",
    slot_feet: "Pieds",
    slot_neck: "Cou",
    slot_ring: "Doigt",
    slot_waist: "Taille",
    slot_back: "Dos",
    slot_main_hand: "Main principale",
    slot_off_hand: "Main secondaire",
    slot_two_hands: "Deux mains",
    slot_none: "Aucun",

    // Filters
    filter_all_types: "Tous les types",
    filter_all_rarities: "Toutes les raretés",
    filter_all_categories: "Toutes les catégories",
    filter_favorites_only: "Favoris uniquement",
    filter_sort_name: "Trier par nom",
    filter_sort_rarity: "Trier par rareté",
    filter_sort_value: "Trier par valeur",
    filter_sort_date: "Trier par date",
    filter_view_grid: "Vue grille",
    filter_view_list: "Vue liste",

    // Vault
    vault_empty: "Le coffre est vide",
    vault_empty_desc: "Utilisez le Générateur pour créer votre premier trésor.",
    vault_distributed: "Distribué",
    vault_in_reserve: "En réserve",
    vault_distribute: "Distribuer",

    // Narrative Thread
    nav_narrative: "Fil Narratif",
    narrative_title: "Fil Narratif",
    narrative_nodes: "nœuds",
    narrative_connections: "connexions",
    narrative_empty: "Votre fil narratif est vide",
    narrative_empty_desc: "Créez votre premier nœud narratif pour construire l'ossature de votre scénario.",
    narrative_create_first: "Créer le premier nœud",
    narrative_new_node: "Nouveau nœud narratif",
    narrative_edit_node: "Modifier le nœud",
    narrative_node_created: "Nœud créé",
    narrative_node_updated: "Nœud modifié",
    narrative_node_deleted: "Nœud supprimé",
    narrative_node_duplicated: "Nœud dupliqué",
    narrative_edge_created: "Connexion créée",
    narrative_edge_updated: "Connexion modifiée",
    narrative_edge_deleted: "Connexion supprimée",
    narrative_confirm_delete: "Confirmer la suppression",
    narrative_delete_node_warning: "Ce nœud et toutes ses connexions seront supprimés. Cette action est irréversible.",
  },

  en: {
    // Common
    app_name: "WyrdMaker",
    app_subtitle: "Campaign Manager",
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    search: "Search...",
    close: "Close",
    confirm: "Confirm",
    back: "Back",
    view_all: "View all",
    no_results: "No results",
    optional: "optional",
    
    // Auth
    login: "Login",
    register: "Register",
    logout: "Logout",
    email: "Email",
    password: "Password",
    username: "Username",
    login_title: "Enter the Adventure",
    register_title: "Join the Guild",
    no_account: "Don't have an account?",
    has_account: "Already registered?",
    login_error: "Invalid email or password",
    register_error: "Registration error",
    
    // Navigation
    nav_dashboard: "Dashboard",
    nav_campaigns: "Campaigns",
    nav_sessions: "Sessions",
    nav_quests: "Quests",
    nav_npcs: "NPCs",
    nav_locations: "Locations",
    nav_maps: "Maps",
    nav_travel: "Travel",
    nav_treasure: "Treasure",
    nav_combat: "Combat",
    nav_messages: "Messages",
    nav_settings: "Settings",

    // Command Palette
    command_palette_placeholder: "Search for a quest, NPC, location...",
    command_palette_no_results: "No results found",
    command_palette_quick_actions: "Quick actions",
    command_palette_search_hint: "Search",

    // Notifications
    notif_title: "Notifications",
    notif_empty: "No notifications",
    notif_mark_all_read: "Mark all as read",
    notif_session_published: "Session recap published",
    notif_session_created: "New session scheduled",
    notif_quest_status_changed: "Quest status changed",
    notif_npc_status_changed: "NPC status changed",
    notif_lore_revealed: "Encyclopedia article revealed",
    notif_report_status_changed: "Report status changed",
    notif_report_admin_response: "Admin response",
    notif_just_now: "just now",
    notif_minutes_ago: "{n}m ago",
    notif_hours_ago: "{n}h ago",
    notif_days_ago: "{n}d ago",

    // Bug Reports
    report_button_title: "Report",
    report_dialog_title: "Report a bug or improvement",
    report_type: "Type",
    report_type_bug: "Bug",
    report_type_feature: "Feature request",
    report_title: "Title",
    report_description: "Description",
    report_priority: "Priority",
    report_priority_low: "Low",
    report_priority_medium: "Medium",
    report_priority_high: "High",
    report_priority_critical: "Critical",
    report_submit: "Submit",
    report_submitting: "Submitting...",
    report_success: "Report submitted successfully",

    // Admin Email Templates
    admin_email_templates: "Email Templates",
    admin_email_templates_title: "Email Templates Management",
    admin_email_templates_save: "Template saved",
    admin_email_templates_test_sent: "Test email sent",
    admin_email_templates_seed: "Default templates restored",

    // Admin Reports
    admin_reports: "Reports",
    report_status_new: "New",
    report_status_acknowledged: "Acknowledged",
    report_status_in_progress: "In progress",
    report_status_resolved: "Resolved",
    report_status_closed: "Closed",
    report_admin_response: "Admin response",
    report_admin_respond: "Respond",
    report_no_reports: "No reports",
    report_settings: "Settings",
    report_mode_disabled: "Disabled",
    report_mode_all_users: "All users",
    report_mode_per_user: "Per user",
    report_mode_label: "Report mode",
    report_mode_description_disabled: "Bug reports are disabled for all users",
    report_mode_description_all_users: "All users can submit reports",
    report_mode_description_per_user: "Only authorized users can submit reports",
    report_delete_confirm: "Are you sure you want to delete this report?",
    report_detail: "Report detail",
    report_by: "By",
    report_created_at: "Created on",

    // Landing
    landing_hero_title: "Master Your Campaigns",
    landing_hero_subtitle: "The all-in-one platform for Game Masters and their players. Manage your campaigns, share your maps, and experience memorable adventures together.",
    landing_cta: "Start Your Adventure",
    landing_feature_1_title: "Sessions & Reports",
    landing_feature_1_desc: "Plan your sessions, track attendance, and write structured session reports.",
    landing_feature_2_title: "Quests & NPCs",
    landing_feature_2_desc: "Manage your plots, characters, and their complex relationships.",
    landing_feature_3_title: "Interactive Maps",
    landing_feature_3_desc: "Create maps with points of interest linked to your quests and locations.",
    landing_feature_4_title: "Treasure Generator",
    landing_feature_4_desc: "Generate balanced D&D 5e treasures with one click.",
    landing_feature_5_title: "Combat Tracker",
    landing_feature_5_desc: "Initiative, HP, conditions, and real-time sharing with players via SSE.",
    landing_feature_6_title: "PDF Character Sheets",
    landing_feature_6_desc: "Import your PDFs and overlay interactive fields. Compatible with any system.",
    landing_feature_7_title: "Fog of War",
    landing_feature_7_desc: "Progressively reveal your maps to players with a fog brush tool.",
    landing_feature_8_title: "Encyclopedia & Lore",
    landing_feature_8_desc: "Built-in wiki with @mentions, bidirectional links, and revelation levels.",
    landing_feature_9_title: "3D Dice Roller",
    landing_feature_9_desc: "Animated 3D dice, advantage/disadvantage, exploding dice, and custom presets.",
    landing_feature_10_title: "Music & Soundboard",
    landing_feature_10_desc: "Audio library with playlists, crossfade, and a soundboard with 100+ categorized sound effects.",
    landing_feature_11_title: "Relationship Graph",
    landing_feature_11_desc: "Visualize connections between NPCs, quests, locations, and lore articles.",
    landing_feature_12_title: "Template Marketplace",
    landing_feature_12_desc: "Browse, import, and share ready-to-play campaigns. Official templates, difficulty sorting, and one-click import.",
    landing_feature_13_title: "Game System Builder",
    landing_feature_13_desc: "Create your own RPG systems: JSON schema, 8 field types, visual PDF editor, and role-based permissions.",
    landing_section_hero_features: "All-in-one campaign management",
    landing_section_visual_title: "Built for GMs and Players",
    landing_section_visual_subtitle: "Powerful tools for the GM, an immersive experience for the players",
    landing_section_power_title: "Power Under the Hood",
    landing_section_power_subtitle: "Advanced features for demanding tables",
    landing_section_stats_campaigns: "Campaigns created",
    landing_section_stats_sessions: "Sessions played",
    landing_section_stats_npcs: "NPCs managed",
    landing_section_stats_maps: "Maps explored",

    // Landing v2
    landing_hero_title_v2: "Your Campaign. Your Legend.",
    landing_hero_subtitle_v2: "The complete toolkit for Game Masters and their players. Manage, share, and experience epic adventures.",
    landing_use_case_gm_title: "Game Masters",
    landing_use_case_gm_desc: "Manage combats, NPCs, maps, and quests from a single dashboard. Stay in control of every session.",
    landing_use_case_player_title: "Players",
    landing_use_case_player_desc: "Access your character sheets, inventory, and session notes in real time.",
    landing_use_case_worldbuilder_title: "World Builders",
    landing_use_case_worldbuilder_desc: "Encyclopedia, timeline, relationship graph: build a rich and consistent universe.",
    landing_features_see_all: "See all features",
    landing_trusted_by: "Trusted by hundreds of tables",

    // Public navigation
    nav_features: "Features",
    nav_pricing: "Pricing",
    nav_updates: "Updates",
    nav_help: "Help",
    nav_contact: "Contact",

    // Footer
    footer_product: "Product",
    footer_support: "Support",
    footer_legal: "Legal",
    footer_tagline: "Forge your legends around the table.",
    footer_copyright: "All rights reserved.",
    footer_terms: "Terms of Service",
    footer_privacy: "Privacy Policy",

    // Features Page
    features_page_title: "Features",
    features_page_subtitle: "Everything you need to manage your TTRPG campaigns, from combat to world building.",
    features_category_campaign: "Campaign Management",
    features_category_campaign_desc: "Plan, organize, and track every aspect of your campaign.",
    features_category_combat: "Combat & Maps",
    features_category_combat_desc: "Real-time tools for epic battles and exploration.",
    features_category_world: "World Building",
    features_category_world_desc: "Bring your universe to life with powerful narrative tools.",
    features_category_assets: "Assets & Media",
    features_category_assets_desc: "Audio, equipment, and treasures for total immersion.",
    features_category_platform: "Platform",
    features_category_platform_desc: "Advanced tools to create and share your game systems.",
    features_cta: "Ready to try?",
    features_cta_desc: "Create your first campaign for free.",

    // Pricing Page
    pricing_page_title: "Simple, transparent pricing",
    pricing_page_subtitle: "Start for free, upgrade when you're ready.",
    pricing_free_name: "Adventurer",
    pricing_free_price: "0",
    pricing_free_desc: "Perfect to discover the platform.",
    pricing_free_f1: "1 active campaign",
    pricing_free_f2: "5 NPCs per campaign",
    pricing_free_f3: "Basic combat tracker",
    pricing_free_f4: "Dice roller",
    pricing_free_f5: "Encyclopedia (10 articles)",
    pricing_pro_name: "Game Master",
    pricing_pro_price: "9",
    pricing_pro_desc: "For GMs who want to unlock everything.",
    pricing_pro_f1: "Unlimited campaigns",
    pricing_pro_f2: "Unlimited NPCs and quests",
    pricing_pro_f3: "Maps with fog of war",
    pricing_pro_f4: "Full music & soundboard",
    pricing_pro_f5: "Custom PDF character sheets",
    pricing_pro_f6: "Relationship graph",
    pricing_pro_f7: "Priority support",
    pricing_guild_name: "Guild",
    pricing_guild_price: "25",
    pricing_guild_desc: "For groups and communities.",
    pricing_guild_f1: "Everything in Pro",
    pricing_guild_f2: "Up to 10 GMs",
    pricing_guild_f3: "Private marketplace",
    pricing_guild_f4: "API access",
    pricing_guild_f5: "Custom branding",
    pricing_guild_f6: "Dedicated support",
    pricing_popular: "Popular",
    pricing_per_month: "/month",
    pricing_start_free: "Start for free",
    pricing_choose: "Choose this plan",
    pricing_contact_sales: "Contact sales",
    pricing_faq_title: "Frequently asked questions",
    pricing_faq_1_q: "Can I change plans at any time?",
    pricing_faq_1_a: "Yes, you can upgrade or downgrade your plan at any time. Changes take effect immediately.",
    pricing_faq_2_q: "Is there a commitment?",
    pricing_faq_2_a: "No, all plans are commitment-free. You can cancel at any time.",
    pricing_faq_3_q: "Is my data secure?",
    pricing_faq_3_a: "Absolutely. Your data is encrypted and backed up daily. We never share your information.",
    pricing_faq_4_q: "Does the Guild plan include unlimited players?",
    pricing_faq_4_a: "Yes, only the number of GMs is limited. Each GM can invite as many players as needed.",

    // Updates Page
    updates_page_title: "What's New",
    updates_page_subtitle: "Follow the latest improvements and fixes to WyrdMaker.",
    updates_badge_new: "New",
    updates_badge_improved: "Improved",
    updates_badge_fixed: "Fixed",

    // Help Page
    help_page_title: "Help Center",
    help_page_subtitle: "Find answers to your most common questions.",
    help_search_placeholder: "Search help...",
    help_category_getting_started: "Getting Started",
    help_category_campaigns: "Campaigns",
    help_category_technical: "Technical",
    help_quick_links_title: "Quick Links",
    help_faq_1_q: "How do I create my first campaign?",
    help_faq_1_a: "After signing up, click 'New Campaign' from the dashboard. Give it a name, choose a game system, and invite your players.",
    help_faq_2_q: "How do I invite players to my campaign?",
    help_faq_2_a: "In the campaign settings, use the 'Members' section to send email invitations or share an invite link.",
    help_faq_3_q: "How does the combat tracker work?",
    help_faq_3_a: "The tracker manages initiative, HP, and conditions. Players see information in real time via a sharing link.",
    help_faq_4_q: "Can I import my own PDF character sheets?",
    help_faq_4_a: "Yes! Upload a character sheet PDF, then use the visual editor to position interactive fields on top of it.",
    help_faq_5_q: "How do I use fog of war?",
    help_faq_5_a: "Upload a map, enable fog of war, then use the brush tool to progressively reveal areas to players.",
    help_faq_6_q: "Is data synchronized in real time?",
    help_faq_6_a: "Yes, combat and maps use SSE (Server-Sent Events) for real-time sync between the GM and players.",
    help_faq_7_q: "What game systems are supported?",
    help_faq_7_a: "WyrdMaker natively supports D&D 5e and Wrath & Glory, and you can create your own systems with the Game System Builder.",
    help_faq_8_q: "How do I contact support?",
    help_faq_8_a: "Use the Contact page or the built-in bug report button in the application.",

    // Contact Page
    contact_page_title: "Contact Us",
    contact_page_subtitle: "Have a question, found a bug, or have a suggestion? We'd love to hear from you.",
    contact_name_label: "Name",
    contact_email_label: "Email",
    contact_subject_label: "Subject",
    contact_message_label: "Message",
    contact_subject_general: "General question",
    contact_subject_bug: "Report a bug",
    contact_subject_feature: "Feature suggestion",
    contact_subject_other: "Other",
    contact_submit: "Send message",
    contact_success: "Message sent! We'll get back to you within 48 hours.",
    contact_info_title: "Other ways to reach us",
    contact_response_time: "Response within 48h",
    contact_email_info: "support@wyrdmaker.com",
    contact_discord_info: "Join our Discord",

    // Dashboard
    dashboard_welcome: "Welcome",
    dashboard_recent_sessions: "Recent sessions",
    dashboard_active_quests: "Active quests",
    dashboard_npcs: "NPCs encountered",
    dashboard_no_campaigns: "No campaigns",
    dashboard_create_first: "Create your first campaign to start your adventure!",
    
    // Campaigns
    campaign: "Campaign",
    campaigns: "Campaigns",
    campaign_create: "New campaign",
    campaign_name: "Campaign name",
    campaign_description: "Description",
    campaign_universe: "Universe",
    campaign_style: "Play style",
    campaign_house_rules: "House rules",
    campaign_banner: "Banner image",
    campaign_members: "Members",
    campaign_invite: "Invite players",
    campaign_invite_code: "Invite code",
    campaign_join: "Join a campaign",
    campaign_role_owner: "Game Master",
    campaign_role_editor: "Co-GM",
    campaign_role_member: "Player",
    campaign_role_readonly: "Spectator",
    
    // Sessions
    session: "Session",
    sessions: "Sessions",
    session_create: "New session",
    session_title: "Title",
    session_date: "Date and time",
    session_location: "Location (IRL/online)",
    session_duration: "Estimated duration (min)",
    session_agenda: "Agenda",
    session_prep: "GM prep notes",
    session_summary: "Narrative summary",
    session_key_events: "Key events",
    session_decisions: "Player decisions",
    session_publish: "Publish to players",
    session_published: "Published",
    session_draft: "Draft",
    session_attendance: "Attendance",
    session_confirmed: "Confirmed",
    session_absent: "Absent",
    session_invited: "Invited",
    
    // Quests
    quest: "Quest",
    quests: "Quests",
    quest_create: "New quest",
    quest_title: "Title",
    quest_summary: "Summary",
    quest_type: "Type",
    quest_type_main: "Main",
    quest_type_side: "Side",
    quest_type_personal: "Personal",
    quest_status: "Status",
    quest_status_unknown: "Unknown",
    quest_status_known: "Known",
    quest_status_in_progress: "In Progress",
    quest_status_completed: "Completed",
    quest_status_failed: "Failed",
    quest_status_abandoned: "Abandoned",
    quest_objectives: "Objectives",
    quest_rewards: "Rewards",
    quest_giver: "Quest giver",
    quest_consequences: "Consequences (GM)",
    quest_hints: "Possible hints",
    quest_acts_title: "Acts (GM)",
    quest_acts_gm_only: "Visible to GM only",
    quest_acts_empty: "No acts defined. Break down your plot structure here.",
    quest_acts_add: "Add an act",
    quest_acts_move_up: "Move up",
    quest_acts_move_down: "Move down",
    quest_acts_added: "Act added",
    quest_acts_title_required: "Title is required",

    // NPCs
    npc: "NPC",
    npcs: "NPCs",
    npc_create: "New NPC",
    npc_name: "Name",
    npc_alias: "Alias",
    npc_race: "Race",
    npc_faction: "Faction",
    npc_role: "Role",
    npc_appearance: "Appearance",
    npc_voice: "Voice and mannerisms",
    npc_public_info: "Public information",
    npc_secrets: "Secrets (GM)",
    npc_what_they_know: "What they know",
    npc_what_they_want: "What they want",
    npc_what_they_hide: "What they hide",
    npc_status: "Status",
    npc_status_alive: "Alive",
    npc_status_dead: "Dead",
    npc_status_missing: "Missing",
    npc_status_hostile: "Hostile",
    npc_status_ally: "Ally",
    npc_relations: "Relations",
    
    // Locations
    location: "Location",
    locations: "Locations",
    location_create: "New location",
    location_name: "Name",
    location_type: "Type",
    location_parent: "Parent location",
    location_description: "Public description",
    location_mj_notes: "GM notes",
    location_events: "Possible events",
    location_types: {
      world: "World",
      continent: "Continent",
      kingdom: "Kingdom",
      region: "Region",
      city: "City",
      district: "District",
      dungeon: "Dungeon",
      room: "Room"
    },
    
    // Visibility
    visibility: "Visibility",
    visibility_mj_only: "GM only",
    visibility_players: "Players",
    visibility_custom: "Custom",
    
    // Messages
    success_saved: "Saved successfully",
    success_deleted: "Deleted successfully",
    success_published: "Published successfully",
    error_generic: "An error occurred",
    error_required: "This field is required",
    
    // Theme
    theme_light: "Light",
    theme_dark: "Dark",
    theme_toggle: "Toggle theme",
    
    // Language
    language: "Language",
    language_fr: "Français",
    language_en: "English",

    // Admin
    nav_admin: "Administration",
    admin_dashboard: "Admin Dashboard",
    admin_users: "Users",
    admin_campaigns: "Campaigns",
    admin_settings: "Site Settings",
    admin_audit_logs: "Audit Logs",
    admin_system: "System",
    admin_maintenance: "Maintenance",

    admin_total_users: "Total Users",
    admin_active_users: "Active Users",
    admin_total_campaigns: "Total Campaigns",
    admin_active_campaigns: "Active Campaigns",
    admin_archived_campaigns: "Archived Campaigns",
    admin_total_sessions: "Sessions Played",
    admin_total_npcs: "NPCs Created",
    admin_total_quests: "Quests Created",
    admin_total_locations: "Locations Created",
    admin_total_maps: "Maps Created",
    admin_total_encounters: "Encounters Created",

    admin_user_create: "Add User",
    admin_user_create_desc: "Create a new user account",
    admin_user_list: "User List",
    admin_user_detail: "User Detail",
    admin_user_activate: "Activate",
    admin_user_deactivate: "Deactivate",
    admin_user_promote: "Promote to Admin",
    admin_user_demote: "Demote",
    admin_user_reset_password: "Reset Password",
    admin_user_delete: "Delete User",
    admin_user_last_login: "Last Login",
    admin_user_status_active: "Active",
    admin_user_status_disabled: "Disabled",
    admin_user_campaigns_count: "Campaigns",
    admin_user_confirm_delete: "Are you sure you want to delete this user? This action is irreversible.",
    admin_user_confirm_deactivate: "Are you sure you want to deactivate this account?",
    admin_new_password: "New password",

    admin_settings_general: "General",
    admin_settings_smtp: "Email (SMTP)",
    admin_settings_security: "Security",
    admin_settings_announcements: "Announcements",

    admin_site_name: "Site Name",
    admin_site_description: "Site Description",
    admin_site_url: "Public URL",
    admin_registration_enabled: "Registration Open",
    admin_max_users: "Max Users (0 = unlimited)",
    admin_max_campaigns: "Max Campaigns per User (0 = unlimited)",
    admin_default_language: "Default Language",
    admin_logo_url: "Logo URL",
    admin_favicon_url: "Favicon URL",

    admin_smtp_host: "SMTP Host",
    admin_smtp_port: "SMTP Port",
    admin_smtp_user: "SMTP User",
    admin_smtp_password: "SMTP Password",
    admin_smtp_tls: "Use TLS",
    admin_smtp_from_email: "From Email",
    admin_smtp_from_name: "From Name",
    admin_email_enabled: "Email Enabled",
    admin_smtp_test: "Send Test Email",
    admin_smtp_test_success: "Test email sent successfully",
    admin_smtp_test_error: "Error sending test email",

    admin_jwt_expiration: "JWT Expiration (hours)",
    admin_password_min_length: "Min. Password Length",
    admin_cors_origins: "CORS Origins (comma-separated)",

    admin_announcement: "Global Announcement",
    admin_announcement_help: "This message will be displayed to all logged-in users.",

    admin_campaign_owner: "Owner",
    admin_campaign_members_count: "Members",
    admin_campaign_archive: "Archive",
    admin_campaign_unarchive: "Unarchive",
    admin_campaign_delete: "Delete",
    admin_campaign_confirm_delete: "Are you sure you want to delete this campaign? All associated data will be lost.",

    admin_audit_action: "Action",
    admin_audit_admin: "Administrator",
    admin_audit_target: "Target",
    admin_audit_date: "Date",
    admin_audit_details: "Details",

    admin_health_check: "Service Status",
    admin_db_status: "Database",
    admin_db_size: "Database Size",
    admin_media_status: "Media Server",
    admin_cleanup_invites: "Clean Up Expired Invites",
    admin_cleanup_tokens: "Clean Up Expired Tokens",
    admin_cleanup_success: "Cleanup completed",
    admin_service_online: "Online",
    admin_service_offline: "Offline",
    admin_songs_count: "Available Songs",
    admin_back_to_site: "Back to Site",

    // Game Systems (admin)
    admin_game_systems: "Game Systems",
    admin_game_system_create: "New System",
    admin_game_system_slug: "Identifier (slug)",
    admin_game_system_name: "Name",
    admin_game_system_publisher: "Publisher",
    admin_game_system_version: "Version",
    admin_game_system_description: "Description",
    admin_game_system_builtin: "Built-in",
    admin_game_system_active: "Active",
    admin_game_system_archive: "Disable",
    admin_game_system_delete: "Delete",
    admin_game_system_confirm_delete: "Delete this system? Associated templates will also be deleted.",
    admin_game_system_no_delete_builtin: "Built-in systems cannot be deleted.",
    admin_game_system_no_delete_campaigns: "This system is used by active campaigns.",
    admin_system_templates: "Sheet Templates",
    admin_template_create: "New Template",
    admin_template_name: "Template Name",
    admin_template_version: "Version",
    admin_template_description: "Description",
    admin_template_fields_schema: "JSON Schema (fields_schema)",
    admin_template_layout: "Layout",
    admin_template_default: "Default Template",
    admin_template_confirm_delete: "Delete this template? Existing sheets will not be affected.",
    admin_template_no_delete: "This template is used by character sheets.",
    admin_json_invalid: "Invalid JSON",

    // Admin — Common terms
    admin_status: "Status",
    admin_name: "Name",
    admin_universe: "Universe",
    admin_created_at: "Created",
    admin_archived: "Archived",
    admin_yes: "Yes",
    admin_no: "No",
    admin_details: "Details",
    admin_statistics: "Statistics",
    admin_platform_content: "Platform Content",
    admin_total_lore: "Lore Articles",
    admin_count_users: "users",
    admin_count_campaigns: "campaigns",
    admin_count_entries: "entries",
    admin_filter_action: "Filter by action...",
    admin_test_btn: "Test",
    admin_db_name: "Database",
    admin_data_size: "Data Size",
    admin_storage_size: "Storage",
    admin_collections_label: "Collections",
    admin_media_label: "Media",
    admin_total_size: "Total Size",
    admin_user_edit: "Edit User",
    admin_user_language: "Language",
    admin_export_csv: "Export CSV",
    admin_maintenance_confirm_title: "Confirm Cleanup",
    admin_maintenance_confirm_desc: "This will delete expired data. Continue?",
    admin_published_at: "Published",
    admin_language_fr: "French",
    admin_language_en: "English",
    marketplace_language: "Content language",

    // Admin — Game systems / Templates extras
    admin_game_system_none: "No game systems configured",
    admin_game_system_disabled: "Disabled",
    admin_game_system_reenable: "Re-enable",
    admin_game_system_slug_help: "Unique identifier, cannot be changed after creation.",
    admin_placeholder_short_desc: "Short description...",
    admin_template_none: "No templates configured",
    admin_template_default_badge: "Default",
    admin_template_sections_count: "section(s)",
    admin_template_fields_count: "field(s)",
    admin_template_pdf_builder: "Open PDF Builder",
    admin_template_preview: "Preview",
    admin_template_set_default: "Set as default",
    admin_template_tab_general: "General",
    admin_template_example: "Example section",

    // Admin — Audio
    admin_audio_title: "Music",
    admin_audio_subtitle: "Manage audio library, tags and collections",
    admin_audio_library: "Library",
    admin_audio_tags: "Tags",
    admin_audio_collections: "Collections",
    admin_audio_total_tracks: "total tracks",
    admin_audio_upload_hint: "Drag audio files here or",
    admin_audio_browse: "browse",
    admin_audio_upload_formats: "MP3, WAV, OGG, FLAC — max 150 MB / file",
    admin_audio_edit_track: "Edit Track",
    admin_audio_title_label: "Title (episodes)",
    admin_audio_tags_label: "Tags (comma-separated)",
    admin_audio_collections_label: "Collections (IDs comma-separated)",
    admin_audio_active: "Active (visible to GMs)",
    admin_audio_change_cover: "Change cover",
    admin_audio_choose_image: "Choose image",
    admin_audio_save_error: "Error saving",
    admin_audio_import_title: "Import files",
    admin_audio_pending: "Pending",
    admin_audio_uploading: "Uploading...",
    admin_audio_done: "Done",
    admin_audio_filter_tag: "Filter by tag",
    admin_audio_all_tags: "All tags",
    admin_audio_all_statuses: "All statuses",
    admin_audio_active_only: "Active",
    admin_audio_disabled_only: "Disabled",
    admin_audio_inactive: "Inactive",
    admin_audio_no_tracks: "No tracks found.",
    admin_audio_delete_track: "Delete this track?",
    admin_audio_permanent_delete: "Permanent deletion (deletes file + metadata)",
    admin_audio_soft_delete_hint: "Unchecked: deactivation only (file preserved).",
    admin_audio_delete_permanent: "Delete permanently",
    admin_audio_deactivate: "Deactivate",
    admin_audio_tags_title: "Audio Tags",
    admin_audio_tags_count: "tag(s) in library",
    admin_audio_add_tag: "Add a tag",
    admin_audio_tag_placeholder: "tag name (e.g. boss)",
    admin_audio_rename: "Rename",
    admin_audio_delete_tag_title: "Delete tag",
    admin_audio_delete_tag_desc: "This tag will be removed from all tracks. This cannot be undone.",
    admin_audio_collections_title: "Audio Collections",
    admin_audio_new_collection: "New Collection",
    admin_audio_edit_collection: "Edit Collection",
    admin_audio_name_required: "Name is required",
    admin_audio_description: "Description",
    admin_audio_description_placeholder: "Optional description",
    admin_audio_cover_image: "Cover image",
    admin_audio_collection_empty: "Empty collection",
    admin_audio_no_collections: "No collections.",
    admin_audio_add_tracks: "Add tracks",
    admin_audio_add_tracks_to: "Add tracks to",
    admin_audio_search_tracks: "Search tracks...",
    admin_audio_in_list: "In list",
    admin_audio_not_found: "Not found",
    admin_audio_delete_collection_title: "Delete collection",
    admin_audio_delete_collection_desc: "Tracks won't be deleted, only unlinked from this collection.",
    admin_audio_series: "Series",
    admin_audio_series_placeholder: "e.g. Battle ambience",

    // Player Inventory
    nav_inventory: "Inventory",
    inventory_title: "My Inventory",
    inventory_empty: "Your inventory is empty",
    inventory_empty_desc: "The GM hasn't assigned any equipment to your character yet.",
    inventory_item_count: "items in inventory",
    equipment_assign_to: "Assign to players",
    equipment_assigned_to: "Assigned to",
    equipment_no_assignment: "Unassigned",
    equipment_holographic: "Holographic card",

    // Character Sheets
    nav_character_sheet: "My Sheet",
    nav_gm_characters: "Player Sheets",
    gm_characters_title: "Player Sheets",
    gm_characters_player: "Player",
    gm_characters_character: "Character",
    gm_characters_status: "Status",
    gm_characters_completion: "Completion",
    gm_characters_last_modified: "Last Modified",
    gm_characters_actions: "Actions",
    gm_characters_sheet_present: "Created",
    gm_characters_sheet_missing: "Missing",
    gm_characters_open: "Open",
    gm_characters_create: "Create",
    gm_characters_view_as_player: "Player View",
    gm_characters_view_as_gm: "GM View",
    character_sheet: "Character Sheet",
    character_sheets: "Character Sheets",
    character_sheet_create: "Create My Sheet",
    character_sheet_edit: "Edit Sheet",
    character_sheet_save: "Save Sheet",
    character_sheet_no_system: "No game system configured for this campaign.",
    character_sheet_no_system_hint: "Ask the GM to assign a game system in campaign settings.",
    character_sheet_no_sheet: "You don't have a character sheet yet.",
    character_sheet_no_template: "No sheet template available for this system.",
    character_sheet_select_template: "Choose a template",
    character_sheet_viewing: "Sheet of",
    character_sheet_gm_view: "GM View — all sections visible",
    character_sheet_other_player: "Player view — restricted sections",
    character_sheet_readonly: "Read-only",
    character_sheet_public: "Visible to other players",
    character_sheet_private: "Private",

    // Campaign system
    campaign_system: "Game System",
    campaign_system_none: "No system",
    campaign_system_change: "Change System",
    campaign_system_select: "Select a system",
    campaign_system_optional: "Game System (optional)",

    // Sheet modification history
    history_tab: "History",
    history_loading: "Loading history...",
    history_no_entries: "No modifications recorded.",
    history_filter_from: "From",
    history_filter_to: "To",
    history_filter_path: "Field (filter)",
    history_filter_apply: "Filter",
    history_filter_reset: "Reset",
    history_load_more: "Load more",
    history_role_player: "Player",
    history_role_gm: "GM",
    history_role_admin: "Admin",
    history_action_create: "Sheet created",
    history_action_update: "Modification",
    history_gm_only_hidden: "(GM fields hidden)",
    history_changed_fields: "field modified",
    history_changed_fields_plural: "fields modified",
    history_empty: "empty",

    // PDF Builder
    pdf_builder_title: "PDF Builder",
    pdf_builder_subtitle: "Build your sheet by annotating an existing PDF",
    pdf_builder_load_pdf: "Load PDF",
    pdf_builder_uploading: "Uploading...",
    pdf_builder_loaded: "PDF loaded",
    pdf_builder_page_of: "Page {0} of {1}",
    pdf_builder_draw_hint: "Click and drag on the PDF to create a field",
    pdf_builder_annotations: "Annotated fields",
    pdf_builder_no_annotations: "No annotated fields yet",
    pdf_builder_field_key: "Field key",
    pdf_builder_field_label: "Label",
    pdf_builder_field_type: "Field type",
    pdf_builder_section_title: "Section title",
    pdf_builder_font_size: "Font size",
    pdf_builder_visibility: "Visibility",
    pdf_builder_editable_by: "Editable by",
    pdf_builder_required: "Required",
    pdf_builder_min: "Min",
    pdf_builder_max: "Max",
    pdf_builder_resource_max_key: "Max field key",
    pdf_builder_save: "Generate & Save",
    pdf_builder_saving: "Saving...",
    pdf_builder_saved: "Template saved successfully",
    pdf_builder_new_field: "New field",
    pdf_builder_edit_field: "Edit field",
    pdf_builder_upload_prompt: "Upload a character sheet PDF to get started",
    pdf_builder_choose: "Choose PDF",

    // PDF Mode (Character Sheet)
    pdf_mode_tab: "PDF View",
    pdf_mode_saving: "Saving...",
    pdf_mode_version_conflict: "Version conflict — reload the page and try again",
    pdf_mode_no_overlay: "No PDF configured for this template",
    pdf_mode_export: "Export PDF",
    pdf_mode_export_error: "Error exporting PDF",
    pdf_mode_engine_error: "Failed to load PDF engine",
    pdf_mode_load_error: "Failed to load PDF",
    pdf_mode_retry: "Retry",
    pdf_mode_loading: "Loading PDF...",

    // Marketplace
    marketplace: "Marketplace",
    marketplace_browse: "Browse Marketplace",
    marketplace_hero_title: "Template Library",
    marketplace_hero_subtitle: "Discover and import ready-to-play campaigns created by the community",
    marketplace_search_placeholder: "Search templates...",
    marketplace_featured: "Featured",
    marketplace_new: "New",
    marketplace_popular: "Popular",
    marketplace_all_templates: "All Templates",
    marketplace_no_results: "No templates found",
    marketplace_no_results_desc: "Try adjusting your filters or search query",
    marketplace_import: "Import this campaign",
    marketplace_importing: "Importing...",
    marketplace_imported: "Campaign imported successfully!",
    marketplace_publish: "Publish to Marketplace",
    marketplace_publish_title: "Publish a Template",
    marketplace_publish_desc: "Share your campaign with the community by turning it into a template",
    marketplace_name: "Template name",
    marketplace_short_desc: "Short description",
    marketplace_long_desc: "Detailed description",
    marketplace_category: "Category",
    marketplace_difficulty: "Difficulty",
    marketplace_universe: "Universe",
    marketplace_game_system: "Game system",
    marketplace_tags: "Tags (comma-separated)",
    marketplace_cover_url: "Cover image URL",
    marketplace_category_oneshot: "One-shot",
    marketplace_category_campaign: "Campaign",
    marketplace_category_module: "Module",
    marketplace_category_adventure: "Adventure",
    marketplace_difficulty_beginner: "Beginner",
    marketplace_difficulty_intermediate: "Intermediate",
    marketplace_difficulty_advanced: "Advanced",
    marketplace_difficulty_expert: "Expert",
    marketplace_status_draft: "Draft",
    marketplace_status_pending: "Pending review",
    marketplace_status_published: "Published",
    marketplace_status_hidden: "Hidden",
    marketplace_included_content: "Included content",
    marketplace_by: "by",
    marketplace_imports_count: "imports",
    marketplace_import_success: "Campaign imported successfully!",
    marketplace_publish_success: "Template submitted successfully!",
    marketplace_official: "Official",
    marketplace_community: "Community",
    marketplace_detail: "View details",
    marketplace_back: "Back to Marketplace",
    marketplace_all_categories: "All categories",
    marketplace_all_difficulties: "All difficulties",
    marketplace_sort_recent: "Most recent",
    marketplace_sort_popular: "Most popular",
    marketplace_sort_name: "Alphabetical",
    admin_marketplace: "Marketplace",
    admin_marketplace_templates: "Templates",
    admin_marketplace_settings: "Settings",
    admin_marketplace_publish_mode: "Publish mode",
    admin_marketplace_mode_admin_only: "Admins only",
    admin_marketplace_mode_global: "All users",
    admin_marketplace_mode_per_user: "Per user",
    admin_marketplace_mode_admin_only_desc: "Only administrators can publish templates",
    admin_marketplace_mode_global_desc: "All users can propose templates",
    admin_marketplace_mode_per_user_desc: "Enable publishing on a per-user basis",
    admin_marketplace_featured: "Featured",
    admin_marketplace_official: "Official",
    admin_marketplace_confirm_delete: "Delete this template from the marketplace?",
    admin_marketplace_publish_template: "Publish",
    admin_marketplace_hide_template: "Hide",
    admin_marketplace_all_statuses: "All statuses",
    admin_marketplace_user_permissions: "User permissions",
    admin_marketplace_can_publish: "Can publish",
    admin_marketplace_save_settings: "Save settings",
    admin_marketplace_settings_saved: "Settings saved",
    admin_marketplace_no_templates: "No templates in the marketplace",
    admin_marketplace_pending_count: "Pending review",
    admin_marketplace_open_campaign: "Open campaign",
    admin_marketplace_open_campaign_desc: "Import template content as an editable campaign",
    admin_marketplace_opening: "Opening...",
    admin_marketplace_save_to_template: "Save to template",
    admin_marketplace_save_to_template_desc: "Sync campaign changes back to the marketplace template",
    admin_marketplace_saving: "Saving...",
    admin_marketplace_save_success: "Campaign data saved to template",
    admin_marketplace_open_success: "Campaign opened successfully",
    admin_marketplace_campaign_exists: "Editing campaign already exists — opening",
    admin_marketplace_linked_campaign: "Linked campaign",
    admin_marketplace_unlink_campaign: "Unlink campaign",
    admin_marketplace_unlink_confirm: "Unlink this campaign from the template? The campaign will remain accessible but won't be synced to the template anymore.",
    marketplace_linked_template: "Linked marketplace template",
    marketplace_save_back: "Save to template",
    marketplace_save_back_desc: "Update the marketplace template with this campaign's current data",
    marketplace_save_back_success: "Marketplace template updated successfully",
    marketplace_save_back_confirm: "Save this campaign's changes to the marketplace template?",
    campaign_delete: "Delete campaign",
    campaign_delete_confirm_title: "Delete this campaign?",
    campaign_delete_confirm_warning: "This action is irreversible. All campaign data will be permanently deleted:",
    campaign_delete_confirm_list: "Sessions, quests, NPCs, locations, maps, encounters, treasures, character sheets, lore articles, timeline events",
    campaign_delete_confirm_marketplace: "The associated marketplace template will not be affected.",
    campaign_delete_confirm_input: "Type the campaign name to confirm:",
    campaign_delete_success: "Campaign deleted successfully",
    campaign_deleting: "Deleting...",
    campaign_leave: "Leave campaign",
    campaign_leave_confirm: "Are you sure you want to leave this campaign? You will only be able to rejoin with a new invite code.",
    campaign_leave_success: "You have left the campaign",

    // Treasure module — tabs
    treasure_tab_generator: "Generator",
    treasure_tab_library: "Library",
    treasure_tab_vault: "Vault",
    treasure_stats_total: "Total GP",
    treasure_stats_items: "Items",
    treasure_stats_favorites: "Favorites",

    // Generator
    treasure_generate: "Generate Treasure",
    treasure_method: "Generation Method",
    treasure_method_level: "By Level",
    treasure_method_cr: "By Challenge Rating",
    treasure_method_budget: "By Budget (GP)",
    treasure_method_location: "By Location Type",
    treasure_method_rarity: "By Rarity",
    treasure_party_level: "Party Level",
    treasure_challenge_rating: "Challenge Rating",
    treasure_budget_gp: "Budget (GP)",
    treasure_location_type: "Location Type",
    treasure_target_rarity: "Target Rarity",
    treasure_estimate: "Estimated Budget",
    treasure_generate_btn: "Generate",
    treasure_reroll: "Reroll",
    treasure_save_to_vault: "Save to Vault",
    treasure_section_coins: "Coins",
    treasure_section_gems: "Gems",
    treasure_section_art: "Art Objects",
    treasure_section_magic: "Magic Items",
    treasure_section_story: "Story Elements",
    treasure_convert_to_card: "Convert to Card",
    treasure_converted: "Item converted to equipment card",

    // Equipment / Library
    equipment_create: "Create Equipment",
    equipment_edit: "Edit Equipment",
    equipment_delete: "Delete Equipment",
    equipment_delete_confirm: "Are you sure you want to delete this equipment?",
    equipment_duplicate: "Duplicate",
    equipment_duplicated: "Equipment duplicated",
    equipment_toggle_favorite: "Favorite",
    equipment_name: "Name",
    equipment_description: "Description",
    equipment_effect: "Effect",
    equipment_stats: "Statistics",
    equipment_weight: "Weight (lb)",
    equipment_value: "Value (GP)",
    equipment_slot: "Slot",
    equipment_charges: "Charges",
    equipment_max_charges: "Max Charges",
    equipment_bonus: "Bonus",
    equipment_requirements: "Requirements",
    equipment_tags: "Tags (comma separated)",
    equipment_image_url: "Image URL",
    equipment_saved: "Equipment saved",
    equipment_deleted: "Equipment deleted",
    equipment_collection_count: "equipment",
    equipment_no_items: "No equipment found",
    equipment_no_items_desc: "Create your first equipment or convert a magic item from the Vault.",

    // Types
    equipment_type_weapon: "Weapon",
    equipment_type_armor: "Armor",
    equipment_type_potion: "Potion",
    equipment_type_scroll: "Scroll",
    equipment_type_wondrous: "Wondrous Item",
    equipment_type_ring: "Ring",
    equipment_type_wand: "Wand",
    equipment_type_staff: "Staff",
    equipment_type_ammunition: "Ammunition",
    equipment_type_tool: "Tool",
    equipment_type_material: "Material",
    equipment_type_quest_item: "Quest Item",

    // Categories
    equipment_category_equipment: "Equipment",
    equipment_category_consumable: "Consumable",
    equipment_category_material: "Material",
    equipment_category_quest_item: "Quest Item",
    equipment_category_artifact: "Artifact",

    // Rarities
    rarity_common: "Common",
    rarity_uncommon: "Uncommon",
    rarity_rare: "Rare",
    rarity_very_rare: "Very Rare",
    rarity_legendary: "Legendary",
    rarity_artifact: "Artifact",

    // Slots
    slot_head: "Head",
    slot_chest: "Chest",
    slot_hands: "Hands",
    slot_feet: "Feet",
    slot_neck: "Neck",
    slot_ring: "Ring",
    slot_waist: "Waist",
    slot_back: "Back",
    slot_main_hand: "Main Hand",
    slot_off_hand: "Off Hand",
    slot_two_hands: "Two-Handed",
    slot_none: "None",

    // Filters
    filter_all_types: "All Types",
    filter_all_rarities: "All Rarities",
    filter_all_categories: "All Categories",
    filter_favorites_only: "Favorites Only",
    filter_sort_name: "Sort by Name",
    filter_sort_rarity: "Sort by Rarity",
    filter_sort_value: "Sort by Value",
    filter_sort_date: "Sort by Date",
    filter_view_grid: "Grid View",
    filter_view_list: "List View",

    // Vault
    vault_empty: "Vault is empty",
    vault_empty_desc: "Use the Generator to create your first treasure.",
    vault_distributed: "Distributed",
    vault_in_reserve: "In Reserve",
    vault_distribute: "Distribute",

    // Narrative Thread
    nav_narrative: "Narrative Thread",
    narrative_title: "Narrative Thread",
    narrative_nodes: "nodes",
    narrative_connections: "connections",
    narrative_empty: "Your narrative thread is empty",
    narrative_empty_desc: "Create your first narrative node to start building your scenario structure.",
    narrative_create_first: "Create First Node",
    narrative_new_node: "New Narrative Node",
    narrative_edit_node: "Edit Node",
    narrative_node_created: "Node created",
    narrative_node_updated: "Node updated",
    narrative_node_deleted: "Node deleted",
    narrative_node_duplicated: "Node duplicated",
    narrative_edge_created: "Connection created",
    narrative_edge_updated: "Connection updated",
    narrative_edge_deleted: "Connection deleted",
    narrative_confirm_delete: "Confirm Deletion",
    narrative_delete_node_warning: "This node and all its connections will be deleted. This action cannot be undone.",
  }
};

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let value = translations[lang] || translations.fr;
  
  for (const k of keys) {
    if (value && typeof value === 'object') {
      value = value[k];
    } else {
      return key;
    }
  }
  
  return value || key;
};

export const t = (key, lang = 'fr') => getTranslation(lang, key);

export default translations;
